import axios from 'axios';

export default {

    //Permet de récuperer les information de l'utilisateur connecté
    get() {
        return axios.get(process.env.VUE_APP_API_URI + '/api/me');
    },

    forgotPassword(email, url){
        let data = {
         'email': email,
         'reset_path':url
        }
        return axios.post(process.env.VUE_APP_API_URI + '/api/forgot-password', data);
    },

    resetPassword(body){
        return axios.post(process.env.VUE_APP_API_URI + '/api/reset-password', body);
    },

    //Permet de récuperer les information de l'utilisateur connecté
    getUserDetail(id) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/user/' + id + '/detail');
    },

    //Permet de modifier les informations de l'utilisateur connecté
    patch(userId, userData) {
        return axios.patch(process.env.VUE_APP_API_URI + '/api/me', userData);
    },

    //Permet de savoir si les condition de la modal d'accueil d'un concours ont été acceptées
    getAcceptModal(concoursId){
        return axios.get(process.env.VUE_APP_API_URI + '/api/me/accept/modal/data/'+concoursId);
    },

    //Permet d'accepter les condition de la modal d'accueil d'un concours
    setAcceptModal(concoursId){
        return axios.get(process.env.VUE_APP_API_URI + '/api/me/accept/modal/accept/'+concoursId);
    },

    modifyNotif(notificationType){
        return axios.get(process.env.VUE_APP_API_URI + '/api/notification/change/'+notificationType);
    },

    addDeviceToken(body){
        return axios.post(process.env.VUE_APP_API_URI + '/api/me/devicetoken', body);
    }
}
